import { RollshopNotificationPage } from "./RollshopNotificationPage";

const RollshopNotification = () => {
	return <RollshopNotificationPage />;
};
export default RollshopNotification;
